import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breton'
})
export class BretonPipe implements PipeTransform {

  transform(motATransformer:string) {
    if(motATransformer == 'pain au chocolat'){
      return 'chocolatine';

      } else {
        return motATransformer;
    }
  }

}
